import { differenceInMilliseconds, parseISO } from 'date-fns'

import { parseServiceDate } from '../MenuHeader/ServiceSelectionGraphql/serviceWeeks'

export function getMenuTimeRemaining(
  closeTime: string | null | undefined,
  now: number,
  timezone?: string | null,
): number {
  if (!closeTime) return 0
  const closing = timezone ? parseServiceDate(closeTime, timezone) : parseISO(closeTime)
  return differenceInMilliseconds(closing, now)
}
